/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var shared_pb = require('./shared_pb.js');
goog.exportSymbol('proto.fleet.Availability', null, global);
goog.exportSymbol('proto.fleet.AvailabilityOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.AvailabilityRequest', null, global);
goog.exportSymbol('proto.fleet.AvailabilityResponse', null, global);
goog.exportSymbol('proto.fleet.AvailabilitySlot', null, global);
goog.exportSymbol('proto.fleet.BulkCancelReservationsRequest', null, global);
goog.exportSymbol('proto.fleet.CancelReservationRequest', null, global);
goog.exportSymbol('proto.fleet.CreateReservationOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.CreateReservationRequest', null, global);
goog.exportSymbol('proto.fleet.CreateReservationResponse', null, global);
goog.exportSymbol('proto.fleet.CreateReservationsRequest', null, global);
goog.exportSymbol('proto.fleet.GetPastReservationOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.GetPastReservationResponse', null, global);
goog.exportSymbol('proto.fleet.GetReservationOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.GetReservationRequest', null, global);
goog.exportSymbol('proto.fleet.GetReservationResponse', null, global);
goog.exportSymbol('proto.fleet.NearestAvailability', null, global);
goog.exportSymbol('proto.fleet.NearestAvailabilityByDay', null, global);
goog.exportSymbol('proto.fleet.NearestAvailabilityByDayOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.NearestAvailabilityByDayResponse', null, global);
goog.exportSymbol('proto.fleet.NearestAvailabilityOrErrorResponse', null, global);
goog.exportSymbol('proto.fleet.NearestAvailabilityRequest', null, global);
goog.exportSymbol('proto.fleet.PastReservation', null, global);
goog.exportSymbol('proto.fleet.Reservation', null, global);
goog.exportSymbol('proto.fleet.StationReservationSortOrder', null, global);
goog.exportSymbol('proto.fleet.StationReservationsRequest', null, global);
goog.exportSymbol('proto.fleet.UpdateReservationRequest', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CancelReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.CancelReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CancelReservationRequest.displayName = 'proto.fleet.CancelReservationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CancelReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CancelReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CancelReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CancelReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CancelReservationRequest}
 */
proto.fleet.CancelReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CancelReservationRequest;
  return proto.fleet.CancelReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CancelReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CancelReservationRequest}
 */
proto.fleet.CancelReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CancelReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CancelReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CancelReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CancelReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 reservation_id = 1;
 * @return {number}
 */
proto.fleet.CancelReservationRequest.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.CancelReservationRequest.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AvailabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.AvailabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AvailabilityRequest.displayName = 'proto.fleet.AvailabilityRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AvailabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    range: (f = msg.getRange()) && shared_pb.LocalDateRange.toObject(includeInstance, f),
    seatCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reservationId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    now: jspb.Message.getFieldWithDefault(msg, 5, ""),
    departTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AvailabilityRequest}
 */
proto.fleet.AvailabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AvailabilityRequest;
  return proto.fleet.AvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AvailabilityRequest}
 */
proto.fleet.AvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = new shared_pb.LocalDateRange;
      reader.readMessage(value,shared_pb.LocalDateRange.deserializeBinaryFromReader);
      msg.setRange(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeatCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNow(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AvailabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AvailabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.LocalDateRange.serializeBinaryToWriter
    );
  }
  f = message.getSeatCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNow();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDepartTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.AvailabilityRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.AvailabilityRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional LocalDateRange range = 2;
 * @return {?proto.fleet.LocalDateRange}
 */
proto.fleet.AvailabilityRequest.prototype.getRange = function() {
  return /** @type{?proto.fleet.LocalDateRange} */ (
    jspb.Message.getWrapperField(this, shared_pb.LocalDateRange, 2));
};


/** @param {?proto.fleet.LocalDateRange|undefined} value */
proto.fleet.AvailabilityRequest.prototype.setRange = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.AvailabilityRequest.prototype.clearRange = function() {
  this.setRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.AvailabilityRequest.prototype.hasRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 seat_count = 3;
 * @return {number}
 */
proto.fleet.AvailabilityRequest.prototype.getSeatCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.AvailabilityRequest.prototype.setSeatCount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 reservation_id = 4;
 * @return {number}
 */
proto.fleet.AvailabilityRequest.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.AvailabilityRequest.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string now = 5;
 * @return {string}
 */
proto.fleet.AvailabilityRequest.prototype.getNow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.fleet.AvailabilityRequest.prototype.setNow = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string depart_time = 6;
 * @return {string}
 */
proto.fleet.AvailabilityRequest.prototype.getDepartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.AvailabilityRequest.prototype.setDepartTime = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 user_id = 7;
 * @return {number}
 */
proto.fleet.AvailabilityRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.fleet.AvailabilityRequest.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailabilityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.NearestAvailabilityRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.NearestAvailabilityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailabilityRequest.displayName = 'proto.fleet.NearestAvailabilityRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.NearestAvailabilityRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailabilityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    targetTime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    targetDateList: jspb.Message.getRepeatedField(msg, 3),
    seatCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    reservationId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    now: jspb.Message.getFieldWithDefault(msg, 6, ""),
    departTime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailabilityRequest}
 */
proto.fleet.NearestAvailabilityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailabilityRequest;
  return proto.fleet.NearestAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailabilityRequest}
 */
proto.fleet.NearestAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTargetDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeatCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNow(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartTime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailabilityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailabilityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTargetTime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTargetDateList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getSeatCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNow();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDepartTime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.NearestAvailabilityRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string target_time = 2;
 * @return {string}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getTargetTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.NearestAvailabilityRequest.prototype.setTargetTime = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string target_date = 3;
 * @return {!Array<string>}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getTargetDateList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.fleet.NearestAvailabilityRequest.prototype.setTargetDateList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.NearestAvailabilityRequest.prototype.addTargetDate = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.fleet.NearestAvailabilityRequest.prototype.clearTargetDateList = function() {
  this.setTargetDateList([]);
};


/**
 * optional int32 seat_count = 4;
 * @return {number}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getSeatCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.NearestAvailabilityRequest.prototype.setSeatCount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 reservation_id = 5;
 * @return {number}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.NearestAvailabilityRequest.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string now = 6;
 * @return {string}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getNow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.NearestAvailabilityRequest.prototype.setNow = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string depart_time = 7;
 * @return {string}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getDepartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.fleet.NearestAvailabilityRequest.prototype.setDepartTime = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 user_id = 8;
 * @return {number}
 */
proto.fleet.NearestAvailabilityRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.fleet.NearestAvailabilityRequest.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.GetReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetReservationRequest.displayName = 'proto.fleet.GetReservationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    range: (f = msg.getRange()) && shared_pb.LocalDateRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetReservationRequest}
 */
proto.fleet.GetReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetReservationRequest;
  return proto.fleet.GetReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetReservationRequest}
 */
proto.fleet.GetReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 3:
      var value = new shared_pb.LocalDateRange;
      reader.readMessage(value,shared_pb.LocalDateRange.deserializeBinaryFromReader);
      msg.setRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_pb.LocalDateRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.GetReservationRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.GetReservationRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 user_id = 2;
 * @return {number}
 */
proto.fleet.GetReservationRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.GetReservationRequest.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional LocalDateRange range = 3;
 * @return {?proto.fleet.LocalDateRange}
 */
proto.fleet.GetReservationRequest.prototype.getRange = function() {
  return /** @type{?proto.fleet.LocalDateRange} */ (
    jspb.Message.getWrapperField(this, shared_pb.LocalDateRange, 3));
};


/** @param {?proto.fleet.LocalDateRange|undefined} value */
proto.fleet.GetReservationRequest.prototype.setRange = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.fleet.GetReservationRequest.prototype.clearRange = function() {
  this.setRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetReservationRequest.prototype.hasRange = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.BulkCancelReservationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.BulkCancelReservationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.BulkCancelReservationsRequest.displayName = 'proto.fleet.BulkCancelReservationsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.BulkCancelReservationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.BulkCancelReservationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.BulkCancelReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.BulkCancelReservationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    date: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.BulkCancelReservationsRequest}
 */
proto.fleet.BulkCancelReservationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.BulkCancelReservationsRequest;
  return proto.fleet.BulkCancelReservationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.BulkCancelReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.BulkCancelReservationsRequest}
 */
proto.fleet.BulkCancelReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.BulkCancelReservationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.BulkCancelReservationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.BulkCancelReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.BulkCancelReservationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.BulkCancelReservationsRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.BulkCancelReservationsRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.fleet.BulkCancelReservationsRequest.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.BulkCancelReservationsRequest.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AvailabilityOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.AvailabilityOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.AvailabilityOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AvailabilityOrErrorResponse.displayName = 'proto.fleet.AvailabilityOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.AvailabilityOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.AvailabilityOrErrorResponse.AvailabilityOneOfCase = {
  AVAILABILITY_ONE_OF_NOT_SET: 0,
  AVAILABILITY: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.AvailabilityOrErrorResponse.AvailabilityOneOfCase}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.getAvailabilityOneOfCase = function() {
  return /** @type {proto.fleet.AvailabilityOrErrorResponse.AvailabilityOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.AvailabilityOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AvailabilityOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AvailabilityOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    availability: (f = msg.getAvailability()) && proto.fleet.AvailabilityResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AvailabilityOrErrorResponse}
 */
proto.fleet.AvailabilityOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AvailabilityOrErrorResponse;
  return proto.fleet.AvailabilityOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AvailabilityOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AvailabilityOrErrorResponse}
 */
proto.fleet.AvailabilityOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.AvailabilityResponse;
      reader.readMessage(value,proto.fleet.AvailabilityResponse.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AvailabilityOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AvailabilityOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.AvailabilityResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional AvailabilityResponse availability = 1;
 * @return {?proto.fleet.AvailabilityResponse}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.getAvailability = function() {
  return /** @type{?proto.fleet.AvailabilityResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.AvailabilityResponse, 1));
};


/** @param {?proto.fleet.AvailabilityResponse|undefined} value */
proto.fleet.AvailabilityOrErrorResponse.prototype.setAvailability = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.AvailabilityOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.AvailabilityOrErrorResponse.prototype.clearAvailability = function() {
  this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.AvailabilityOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.AvailabilityOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.AvailabilityOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.AvailabilityOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AvailabilityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AvailabilityResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.AvailabilityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AvailabilityResponse.displayName = 'proto.fleet.AvailabilityResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AvailabilityResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AvailabilityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scheduleList: jspb.Message.toObjectList(msg.getScheduleList(),
    proto.fleet.Availability.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AvailabilityResponse}
 */
proto.fleet.AvailabilityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AvailabilityResponse;
  return proto.fleet.AvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AvailabilityResponse}
 */
proto.fleet.AvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Availability;
      reader.readMessage(value,proto.fleet.Availability.deserializeBinaryFromReader);
      msg.addSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AvailabilityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AvailabilityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScheduleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.Availability.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Availability schedule = 1;
 * @return {!Array<!proto.fleet.Availability>}
 */
proto.fleet.AvailabilityResponse.prototype.getScheduleList = function() {
  return /** @type{!Array<!proto.fleet.Availability>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.Availability, 1));
};


/** @param {!Array<!proto.fleet.Availability>} value */
proto.fleet.AvailabilityResponse.prototype.setScheduleList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.Availability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.Availability}
 */
proto.fleet.AvailabilityResponse.prototype.addSchedule = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.Availability, opt_index);
};


proto.fleet.AvailabilityResponse.prototype.clearScheduleList = function() {
  this.setScheduleList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateReservationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.CreateReservationsRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.CreateReservationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateReservationsRequest.displayName = 'proto.fleet.CreateReservationsRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.CreateReservationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateReservationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateReservationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationsList: jspb.Message.toObjectList(msg.getReservationsList(),
    proto.fleet.CreateReservationRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateReservationsRequest}
 */
proto.fleet.CreateReservationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateReservationsRequest;
  return proto.fleet.CreateReservationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateReservationsRequest}
 */
proto.fleet.CreateReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.CreateReservationRequest;
      reader.readMessage(value,proto.fleet.CreateReservationRequest.deserializeBinaryFromReader);
      msg.addReservations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateReservationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateReservationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.CreateReservationRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CreateReservationRequest reservations = 1;
 * @return {!Array<!proto.fleet.CreateReservationRequest>}
 */
proto.fleet.CreateReservationsRequest.prototype.getReservationsList = function() {
  return /** @type{!Array<!proto.fleet.CreateReservationRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.CreateReservationRequest, 1));
};


/** @param {!Array<!proto.fleet.CreateReservationRequest>} value */
proto.fleet.CreateReservationsRequest.prototype.setReservationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.CreateReservationRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.CreateReservationRequest}
 */
proto.fleet.CreateReservationsRequest.prototype.addReservations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.CreateReservationRequest, opt_index);
};


proto.fleet.CreateReservationsRequest.prototype.clearReservationsList = function() {
  this.setReservationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.CreateReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateReservationRequest.displayName = 'proto.fleet.CreateReservationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reservationTimestamp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pickupLocationId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dropoffLocationId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    numberOfSeats: jspb.Message.getFieldWithDefault(msg, 5, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateReservationRequest}
 */
proto.fleet.CreateReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateReservationRequest;
  return proto.fleet.CreateReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateReservationRequest}
 */
proto.fleet.CreateReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservationTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPickupLocationId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDropoffLocationId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfSeats(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReservationTimestamp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPickupLocationId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDropoffLocationId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNumberOfSeats();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 operating_area_id = 1;
 * @return {number}
 */
proto.fleet.CreateReservationRequest.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.CreateReservationRequest.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string reservation_timestamp = 2;
 * @return {string}
 */
proto.fleet.CreateReservationRequest.prototype.getReservationTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.CreateReservationRequest.prototype.setReservationTimestamp = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 pickup_location_id = 3;
 * @return {number}
 */
proto.fleet.CreateReservationRequest.prototype.getPickupLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.CreateReservationRequest.prototype.setPickupLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 dropoff_location_id = 4;
 * @return {number}
 */
proto.fleet.CreateReservationRequest.prototype.getDropoffLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.CreateReservationRequest.prototype.setDropoffLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 number_of_seats = 5;
 * @return {number}
 */
proto.fleet.CreateReservationRequest.prototype.getNumberOfSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.CreateReservationRequest.prototype.setNumberOfSeats = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fleet.CreateReservationRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.CreateReservationRequest.prototype.setNotes = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.CreateReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateReservationResponse.displayName = 'proto.fleet.CreateReservationResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateReservationResponse}
 */
proto.fleet.CreateReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateReservationResponse;
  return proto.fleet.CreateReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateReservationResponse}
 */
proto.fleet.CreateReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 reservation_id = 1;
 * @return {number}
 */
proto.fleet.CreateReservationResponse.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.CreateReservationResponse.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.CreateReservationOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.CreateReservationOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.CreateReservationOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.CreateReservationOrErrorResponse.displayName = 'proto.fleet.CreateReservationOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.CreateReservationOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.CreateReservationOrErrorResponse.CreateReservationOneOfCase = {
  CREATE_RESERVATION_ONE_OF_NOT_SET: 0,
  CREATE_RESERVATION: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.CreateReservationOrErrorResponse.CreateReservationOneOfCase}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.getCreateReservationOneOfCase = function() {
  return /** @type {proto.fleet.CreateReservationOrErrorResponse.CreateReservationOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.CreateReservationOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.CreateReservationOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.CreateReservationOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    createReservation: (f = msg.getCreateReservation()) && proto.fleet.CreateReservationResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.CreateReservationOrErrorResponse}
 */
proto.fleet.CreateReservationOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.CreateReservationOrErrorResponse;
  return proto.fleet.CreateReservationOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.CreateReservationOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.CreateReservationOrErrorResponse}
 */
proto.fleet.CreateReservationOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.CreateReservationResponse;
      reader.readMessage(value,proto.fleet.CreateReservationResponse.deserializeBinaryFromReader);
      msg.setCreateReservation(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.CreateReservationOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.CreateReservationOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.CreateReservationOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreateReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.CreateReservationResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional CreateReservationResponse create_reservation = 1;
 * @return {?proto.fleet.CreateReservationResponse}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.getCreateReservation = function() {
  return /** @type{?proto.fleet.CreateReservationResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.CreateReservationResponse, 1));
};


/** @param {?proto.fleet.CreateReservationResponse|undefined} value */
proto.fleet.CreateReservationOrErrorResponse.prototype.setCreateReservation = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.CreateReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.CreateReservationOrErrorResponse.prototype.clearCreateReservation = function() {
  this.setCreateReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.hasCreateReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.CreateReservationOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.CreateReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.CreateReservationOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.CreateReservationOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.UpdateReservationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.UpdateReservationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.UpdateReservationRequest.displayName = 'proto.fleet.UpdateReservationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.UpdateReservationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.UpdateReservationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.UpdateReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateReservationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reservationTimestamp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pickupLocationId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    dropoffLocationId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    numberOfSeats: jspb.Message.getFieldWithDefault(msg, 5, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.UpdateReservationRequest}
 */
proto.fleet.UpdateReservationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.UpdateReservationRequest;
  return proto.fleet.UpdateReservationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.UpdateReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.UpdateReservationRequest}
 */
proto.fleet.UpdateReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservationTimestamp(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPickupLocationId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDropoffLocationId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfSeats(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.UpdateReservationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.UpdateReservationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.UpdateReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.UpdateReservationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getReservationTimestamp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPickupLocationId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDropoffLocationId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getNumberOfSeats();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 reservation_id = 1;
 * @return {number}
 */
proto.fleet.UpdateReservationRequest.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.UpdateReservationRequest.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string reservation_timestamp = 2;
 * @return {string}
 */
proto.fleet.UpdateReservationRequest.prototype.getReservationTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.UpdateReservationRequest.prototype.setReservationTimestamp = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 pickup_location_id = 3;
 * @return {number}
 */
proto.fleet.UpdateReservationRequest.prototype.getPickupLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.UpdateReservationRequest.prototype.setPickupLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 dropoff_location_id = 4;
 * @return {number}
 */
proto.fleet.UpdateReservationRequest.prototype.getDropoffLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.UpdateReservationRequest.prototype.setDropoffLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 number_of_seats = 5;
 * @return {number}
 */
proto.fleet.UpdateReservationRequest.prototype.getNumberOfSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.UpdateReservationRequest.prototype.setNumberOfSeats = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.fleet.UpdateReservationRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.UpdateReservationRequest.prototype.setNotes = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetReservationResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetReservationResponse.displayName = 'proto.fleet.GetReservationResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetReservationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationsList: jspb.Message.toObjectList(msg.getReservationsList(),
    proto.fleet.Reservation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetReservationResponse}
 */
proto.fleet.GetReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetReservationResponse;
  return proto.fleet.GetReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetReservationResponse}
 */
proto.fleet.GetReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Reservation;
      reader.readMessage(value,proto.fleet.Reservation.deserializeBinaryFromReader);
      msg.addReservations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.Reservation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Reservation reservations = 1;
 * @return {!Array<!proto.fleet.Reservation>}
 */
proto.fleet.GetReservationResponse.prototype.getReservationsList = function() {
  return /** @type{!Array<!proto.fleet.Reservation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.Reservation, 1));
};


/** @param {!Array<!proto.fleet.Reservation>} value */
proto.fleet.GetReservationResponse.prototype.setReservationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.Reservation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.Reservation}
 */
proto.fleet.GetReservationResponse.prototype.addReservations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.Reservation, opt_index);
};


proto.fleet.GetReservationResponse.prototype.clearReservationsList = function() {
  this.setReservationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetReservationOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.GetReservationOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.GetReservationOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetReservationOrErrorResponse.displayName = 'proto.fleet.GetReservationOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.GetReservationOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.GetReservationOrErrorResponse.GetReservationOneOfCase = {
  GET_RESERVATION_ONE_OF_NOT_SET: 0,
  GET_RESERVATION: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.GetReservationOrErrorResponse.GetReservationOneOfCase}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.getGetReservationOneOfCase = function() {
  return /** @type {proto.fleet.GetReservationOrErrorResponse.GetReservationOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.GetReservationOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetReservationOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetReservationOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    getReservation: (f = msg.getGetReservation()) && proto.fleet.GetReservationResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetReservationOrErrorResponse}
 */
proto.fleet.GetReservationOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetReservationOrErrorResponse;
  return proto.fleet.GetReservationOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetReservationOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetReservationOrErrorResponse}
 */
proto.fleet.GetReservationOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.GetReservationResponse;
      reader.readMessage(value,proto.fleet.GetReservationResponse.deserializeBinaryFromReader);
      msg.setGetReservation(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetReservationOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetReservationOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetReservationOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGetReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.GetReservationResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetReservationResponse get_reservation = 1;
 * @return {?proto.fleet.GetReservationResponse}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.getGetReservation = function() {
  return /** @type{?proto.fleet.GetReservationResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.GetReservationResponse, 1));
};


/** @param {?proto.fleet.GetReservationResponse|undefined} value */
proto.fleet.GetReservationOrErrorResponse.prototype.setGetReservation = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.GetReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetReservationOrErrorResponse.prototype.clearGetReservation = function() {
  this.setGetReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.hasGetReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.GetReservationOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.GetReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetReservationOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetReservationOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetPastReservationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.GetPastReservationResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.GetPastReservationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetPastReservationResponse.displayName = 'proto.fleet.GetPastReservationResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.GetPastReservationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetPastReservationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetPastReservationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetPastReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetPastReservationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationsList: jspb.Message.toObjectList(msg.getReservationsList(),
    proto.fleet.PastReservation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetPastReservationResponse}
 */
proto.fleet.GetPastReservationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetPastReservationResponse;
  return proto.fleet.GetPastReservationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetPastReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetPastReservationResponse}
 */
proto.fleet.GetPastReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.PastReservation;
      reader.readMessage(value,proto.fleet.PastReservation.deserializeBinaryFromReader);
      msg.addReservations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetPastReservationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetPastReservationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetPastReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetPastReservationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.PastReservation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PastReservation reservations = 1;
 * @return {!Array<!proto.fleet.PastReservation>}
 */
proto.fleet.GetPastReservationResponse.prototype.getReservationsList = function() {
  return /** @type{!Array<!proto.fleet.PastReservation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.PastReservation, 1));
};


/** @param {!Array<!proto.fleet.PastReservation>} value */
proto.fleet.GetPastReservationResponse.prototype.setReservationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.PastReservation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.PastReservation}
 */
proto.fleet.GetPastReservationResponse.prototype.addReservations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.PastReservation, opt_index);
};


proto.fleet.GetPastReservationResponse.prototype.clearReservationsList = function() {
  this.setReservationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.GetPastReservationOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.GetPastReservationOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.GetPastReservationOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.GetPastReservationOrErrorResponse.displayName = 'proto.fleet.GetPastReservationOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.GetPastReservationOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.GetPastReservationOrErrorResponse.GetPastReservationOneOfCase = {
  GET_PAST_RESERVATION_ONE_OF_NOT_SET: 0,
  GET_PAST_RESERVATION: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.GetPastReservationOrErrorResponse.GetPastReservationOneOfCase}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.getGetPastReservationOneOfCase = function() {
  return /** @type {proto.fleet.GetPastReservationOrErrorResponse.GetPastReservationOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.GetPastReservationOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.GetPastReservationOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.GetPastReservationOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetPastReservationOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    getPastReservation: (f = msg.getGetPastReservation()) && proto.fleet.GetPastReservationResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.GetPastReservationOrErrorResponse}
 */
proto.fleet.GetPastReservationOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.GetPastReservationOrErrorResponse;
  return proto.fleet.GetPastReservationOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.GetPastReservationOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.GetPastReservationOrErrorResponse}
 */
proto.fleet.GetPastReservationOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.GetPastReservationResponse;
      reader.readMessage(value,proto.fleet.GetPastReservationResponse.deserializeBinaryFromReader);
      msg.setGetPastReservation(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.GetPastReservationOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.GetPastReservationOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.GetPastReservationOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGetPastReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.GetPastReservationResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetPastReservationResponse get_past_reservation = 1;
 * @return {?proto.fleet.GetPastReservationResponse}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.getGetPastReservation = function() {
  return /** @type{?proto.fleet.GetPastReservationResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.GetPastReservationResponse, 1));
};


/** @param {?proto.fleet.GetPastReservationResponse|undefined} value */
proto.fleet.GetPastReservationOrErrorResponse.prototype.setGetPastReservation = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.GetPastReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetPastReservationOrErrorResponse.prototype.clearGetPastReservation = function() {
  this.setGetPastReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.hasGetPastReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.GetPastReservationOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.GetPastReservationOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.GetPastReservationOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.GetPastReservationOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailabilityOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.NearestAvailabilityOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.NearestAvailabilityOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailabilityOrErrorResponse.displayName = 'proto.fleet.NearestAvailabilityOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.NearestAvailabilityOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.NearestAvailabilityOneOfCase = {
  NEAREST_AVAILABILITY_ONE_OF_NOT_SET: 0,
  NEAREST_AVAILABILITY: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.NearestAvailabilityOrErrorResponse.NearestAvailabilityOneOfCase}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.getNearestAvailabilityOneOfCase = function() {
  return /** @type {proto.fleet.NearestAvailabilityOrErrorResponse.NearestAvailabilityOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.NearestAvailabilityOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailabilityOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailabilityOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    nearestAvailability: (f = msg.getNearestAvailability()) && proto.fleet.NearestAvailability.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailabilityOrErrorResponse}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailabilityOrErrorResponse;
  return proto.fleet.NearestAvailabilityOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailabilityOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailabilityOrErrorResponse}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.NearestAvailability;
      reader.readMessage(value,proto.fleet.NearestAvailability.deserializeBinaryFromReader);
      msg.setNearestAvailability(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailabilityOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailabilityOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNearestAvailability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.NearestAvailability.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional NearestAvailability nearest_availability = 1;
 * @return {?proto.fleet.NearestAvailability}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.getNearestAvailability = function() {
  return /** @type{?proto.fleet.NearestAvailability} */ (
    jspb.Message.getWrapperField(this, proto.fleet.NearestAvailability, 1));
};


/** @param {?proto.fleet.NearestAvailability|undefined} value */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.setNearestAvailability = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.NearestAvailabilityOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.NearestAvailabilityOrErrorResponse.prototype.clearNearestAvailability = function() {
  this.setNearestAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.hasNearestAvailability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.NearestAvailabilityOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.NearestAvailabilityOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.NearestAvailabilityOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.NearestAvailabilityByDayOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.NearestAvailabilityByDayOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailabilityByDayOrErrorResponse.displayName = 'proto.fleet.NearestAvailabilityByDayOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.NearestAvailabilityOneOfCase = {
  NEAREST_AVAILABILITY_ONE_OF_NOT_SET: 0,
  NEAREST_AVAILABILITY: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.NearestAvailabilityByDayOrErrorResponse.NearestAvailabilityOneOfCase}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.getNearestAvailabilityOneOfCase = function() {
  return /** @type {proto.fleet.NearestAvailabilityByDayOrErrorResponse.NearestAvailabilityOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.NearestAvailabilityByDayOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailabilityByDayOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailabilityByDayOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    nearestAvailability: (f = msg.getNearestAvailability()) && proto.fleet.NearestAvailabilityByDayResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailabilityByDayOrErrorResponse}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailabilityByDayOrErrorResponse;
  return proto.fleet.NearestAvailabilityByDayOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailabilityByDayOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailabilityByDayOrErrorResponse}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.NearestAvailabilityByDayResponse;
      reader.readMessage(value,proto.fleet.NearestAvailabilityByDayResponse.deserializeBinaryFromReader);
      msg.setNearestAvailability(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailabilityByDayOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailabilityByDayOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNearestAvailability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.NearestAvailabilityByDayResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional NearestAvailabilityByDayResponse nearest_availability = 1;
 * @return {?proto.fleet.NearestAvailabilityByDayResponse}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.getNearestAvailability = function() {
  return /** @type{?proto.fleet.NearestAvailabilityByDayResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.NearestAvailabilityByDayResponse, 1));
};


/** @param {?proto.fleet.NearestAvailabilityByDayResponse|undefined} value */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.setNearestAvailability = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.NearestAvailabilityByDayOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.clearNearestAvailability = function() {
  this.setNearestAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.hasNearestAvailability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.NearestAvailabilityByDayOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.NearestAvailabilityByDayOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailabilityByDayResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.NearestAvailabilityByDayResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.NearestAvailabilityByDayResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailabilityByDayResponse.displayName = 'proto.fleet.NearestAvailabilityByDayResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.NearestAvailabilityByDayResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailabilityByDayResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailabilityByDayResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailabilityByDayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDayResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    availabilityList: jspb.Message.toObjectList(msg.getAvailabilityList(),
    proto.fleet.NearestAvailabilityByDay.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailabilityByDayResponse}
 */
proto.fleet.NearestAvailabilityByDayResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailabilityByDayResponse;
  return proto.fleet.NearestAvailabilityByDayResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailabilityByDayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailabilityByDayResponse}
 */
proto.fleet.NearestAvailabilityByDayResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.NearestAvailabilityByDay;
      reader.readMessage(value,proto.fleet.NearestAvailabilityByDay.deserializeBinaryFromReader);
      msg.addAvailability(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailabilityByDayResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailabilityByDayResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailabilityByDayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDayResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailabilityList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.NearestAvailabilityByDay.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NearestAvailabilityByDay availability = 1;
 * @return {!Array<!proto.fleet.NearestAvailabilityByDay>}
 */
proto.fleet.NearestAvailabilityByDayResponse.prototype.getAvailabilityList = function() {
  return /** @type{!Array<!proto.fleet.NearestAvailabilityByDay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.NearestAvailabilityByDay, 1));
};


/** @param {!Array<!proto.fleet.NearestAvailabilityByDay>} value */
proto.fleet.NearestAvailabilityByDayResponse.prototype.setAvailabilityList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.NearestAvailabilityByDay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.NearestAvailabilityByDay}
 */
proto.fleet.NearestAvailabilityByDayResponse.prototype.addAvailability = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.NearestAvailabilityByDay, opt_index);
};


proto.fleet.NearestAvailabilityByDayResponse.prototype.clearAvailabilityList = function() {
  this.setAvailabilityList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.NearestAvailability.repeatedFields_, null);
};
goog.inherits(proto.fleet.NearestAvailability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailability.displayName = 'proto.fleet.NearestAvailability';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.NearestAvailability.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailability.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailability.toObject = function(includeInstance, msg) {
  var f, obj = {
    beforeList: jspb.Message.getRepeatedField(msg, 1),
    afterList: jspb.Message.getRepeatedField(msg, 2),
    atList: jspb.Message.getRepeatedField(msg, 3),
    timeZone: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailability}
 */
proto.fleet.NearestAvailability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailability;
  return proto.fleet.NearestAvailability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailability}
 */
proto.fleet.NearestAvailability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addBefore(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAfter(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeforeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAfterList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getAtList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getTimeZone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated string before = 1;
 * @return {!Array<string>}
 */
proto.fleet.NearestAvailability.prototype.getBeforeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.fleet.NearestAvailability.prototype.setBeforeList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.NearestAvailability.prototype.addBefore = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.NearestAvailability.prototype.clearBeforeList = function() {
  this.setBeforeList([]);
};


/**
 * repeated string after = 2;
 * @return {!Array<string>}
 */
proto.fleet.NearestAvailability.prototype.getAfterList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/** @param {!Array<string>} value */
proto.fleet.NearestAvailability.prototype.setAfterList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.NearestAvailability.prototype.addAfter = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.fleet.NearestAvailability.prototype.clearAfterList = function() {
  this.setAfterList([]);
};


/**
 * repeated string at = 3;
 * @return {!Array<string>}
 */
proto.fleet.NearestAvailability.prototype.getAtList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.fleet.NearestAvailability.prototype.setAtList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.fleet.NearestAvailability.prototype.addAt = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.fleet.NearestAvailability.prototype.clearAtList = function() {
  this.setAtList([]);
};


/**
 * optional string time_zone = 4;
 * @return {string}
 */
proto.fleet.NearestAvailability.prototype.getTimeZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.NearestAvailability.prototype.setTimeZone = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.NearestAvailabilityByDay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.NearestAvailabilityByDay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.NearestAvailabilityByDay.displayName = 'proto.fleet.NearestAvailabilityByDay';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.NearestAvailabilityByDay.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.NearestAvailabilityByDay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.NearestAvailabilityByDay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDay.toObject = function(includeInstance, msg) {
  var f, obj = {
    availability: (f = msg.getAvailability()) && proto.fleet.NearestAvailability.toObject(includeInstance, f),
    date: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.NearestAvailabilityByDay}
 */
proto.fleet.NearestAvailabilityByDay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.NearestAvailabilityByDay;
  return proto.fleet.NearestAvailabilityByDay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.NearestAvailabilityByDay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.NearestAvailabilityByDay}
 */
proto.fleet.NearestAvailabilityByDay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.NearestAvailability;
      reader.readMessage(value,proto.fleet.NearestAvailability.deserializeBinaryFromReader);
      msg.setAvailability(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.NearestAvailabilityByDay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.NearestAvailabilityByDay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.NearestAvailabilityByDay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.NearestAvailabilityByDay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailability();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.NearestAvailability.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional NearestAvailability availability = 1;
 * @return {?proto.fleet.NearestAvailability}
 */
proto.fleet.NearestAvailabilityByDay.prototype.getAvailability = function() {
  return /** @type{?proto.fleet.NearestAvailability} */ (
    jspb.Message.getWrapperField(this, proto.fleet.NearestAvailability, 1));
};


/** @param {?proto.fleet.NearestAvailability|undefined} value */
proto.fleet.NearestAvailabilityByDay.prototype.setAvailability = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.NearestAvailabilityByDay.prototype.clearAvailability = function() {
  this.setAvailability(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.NearestAvailabilityByDay.prototype.hasAvailability = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string date = 2;
 * @return {string}
 */
proto.fleet.NearestAvailabilityByDay.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.NearestAvailabilityByDay.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.Reservation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.Reservation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.Reservation.displayName = 'proto.fleet.Reservation';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.Reservation.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.Reservation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.Reservation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Reservation.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservationId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scheduleId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    reservationTimestamp: jspb.Message.getFieldWithDefault(msg, 4, ""),
    pickupLocationId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    dropoffLocationId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numberOfSeats: jspb.Message.getFieldWithDefault(msg, 7, 0),
    notes: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isCancelled: jspb.Message.getFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.Reservation}
 */
proto.fleet.Reservation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.Reservation;
  return proto.fleet.Reservation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.Reservation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.Reservation}
 */
proto.fleet.Reservation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReservationId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScheduleId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setReservationTimestamp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPickupLocationId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDropoffLocationId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfSeats(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCancelled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.Reservation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.Reservation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.Reservation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Reservation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getScheduleId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReservationTimestamp();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPickupLocationId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDropoffLocationId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNumberOfSeats();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getIsCancelled();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional int32 reservation_id = 1;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getReservationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setReservationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 schedule_id = 2;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getScheduleId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setScheduleId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 operating_area_id = 3;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string reservation_timestamp = 4;
 * @return {string}
 */
proto.fleet.Reservation.prototype.getReservationTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.Reservation.prototype.setReservationTimestamp = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 pickup_location_id = 5;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getPickupLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setPickupLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 dropoff_location_id = 6;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getDropoffLocationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setDropoffLocationId = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 number_of_seats = 7;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getNumberOfSeats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setNumberOfSeats = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string notes = 8;
 * @return {string}
 */
proto.fleet.Reservation.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.fleet.Reservation.prototype.setNotes = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 user_id = 9;
 * @return {number}
 */
proto.fleet.Reservation.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.fleet.Reservation.prototype.setUserId = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool is_cancelled = 11;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.Reservation.prototype.getIsCancelled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 11, false));
};


/** @param {boolean} value */
proto.fleet.Reservation.prototype.setIsCancelled = function(value) {
  jspb.Message.setProto3BooleanField(this, 11, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PastReservation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PastReservation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PastReservation.displayName = 'proto.fleet.PastReservation';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PastReservation.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PastReservation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PastReservation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PastReservation.toObject = function(includeInstance, msg) {
  var f, obj = {
    reservation: (f = msg.getReservation()) && proto.fleet.Reservation.toObject(includeInstance, f),
    isCancelled: jspb.Message.getFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PastReservation}
 */
proto.fleet.PastReservation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PastReservation;
  return proto.fleet.PastReservation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PastReservation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PastReservation}
 */
proto.fleet.PastReservation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Reservation;
      reader.readMessage(value,proto.fleet.Reservation.deserializeBinaryFromReader);
      msg.setReservation(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCancelled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PastReservation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PastReservation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PastReservation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PastReservation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReservation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.Reservation.serializeBinaryToWriter
    );
  }
  f = message.getIsCancelled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Reservation reservation = 1;
 * @return {?proto.fleet.Reservation}
 */
proto.fleet.PastReservation.prototype.getReservation = function() {
  return /** @type{?proto.fleet.Reservation} */ (
    jspb.Message.getWrapperField(this, proto.fleet.Reservation, 1));
};


/** @param {?proto.fleet.Reservation|undefined} value */
proto.fleet.PastReservation.prototype.setReservation = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.PastReservation.prototype.clearReservation = function() {
  this.setReservation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PastReservation.prototype.hasReservation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_cancelled = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.PastReservation.prototype.getIsCancelled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.fleet.PastReservation.prototype.setIsCancelled = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.Availability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.Availability.repeatedFields_, null);
};
goog.inherits(proto.fleet.Availability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.Availability.displayName = 'proto.fleet.Availability';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.Availability.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.Availability.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.Availability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.Availability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Availability.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slotsList: jspb.Message.toObjectList(msg.getSlotsList(),
    proto.fleet.AvailabilitySlot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.Availability}
 */
proto.fleet.Availability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.Availability;
  return proto.fleet.Availability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.Availability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.Availability}
 */
proto.fleet.Availability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.fleet.AvailabilitySlot;
      reader.readMessage(value,proto.fleet.AvailabilitySlot.deserializeBinaryFromReader);
      msg.addSlots(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.Availability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.Availability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.Availability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Availability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fleet.AvailabilitySlot.serializeBinaryToWriter
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.fleet.Availability.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.Availability.prototype.setDate = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated AvailabilitySlot slots = 2;
 * @return {!Array<!proto.fleet.AvailabilitySlot>}
 */
proto.fleet.Availability.prototype.getSlotsList = function() {
  return /** @type{!Array<!proto.fleet.AvailabilitySlot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.AvailabilitySlot, 2));
};


/** @param {!Array<!proto.fleet.AvailabilitySlot>} value */
proto.fleet.Availability.prototype.setSlotsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fleet.AvailabilitySlot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.AvailabilitySlot}
 */
proto.fleet.Availability.prototype.addSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet.AvailabilitySlot, opt_index);
};


proto.fleet.Availability.prototype.clearSlotsList = function() {
  this.setSlotsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AvailabilitySlot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AvailabilitySlot.repeatedFields_, null);
};
goog.inherits(proto.fleet.AvailabilitySlot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AvailabilitySlot.displayName = 'proto.fleet.AvailabilitySlot';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AvailabilitySlot.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AvailabilitySlot.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AvailabilitySlot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AvailabilitySlot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilitySlot.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, ""),
    seatsRemaining: jspb.Message.getFieldWithDefault(msg, 2, 0),
    leadTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reservationsList: jspb.Message.toObjectList(msg.getReservationsList(),
    proto.fleet.Reservation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AvailabilitySlot}
 */
proto.fleet.AvailabilitySlot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AvailabilitySlot;
  return proto.fleet.AvailabilitySlot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AvailabilitySlot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AvailabilitySlot}
 */
proto.fleet.AvailabilitySlot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSeatsRemaining(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadTime(value);
      break;
    case 4:
      var value = new proto.fleet.Reservation;
      reader.readMessage(value,proto.fleet.Reservation.deserializeBinaryFromReader);
      msg.addReservations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AvailabilitySlot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AvailabilitySlot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AvailabilitySlot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AvailabilitySlot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSeatsRemaining();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLeadTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReservationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.fleet.Reservation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string timestamp = 1;
 * @return {string}
 */
proto.fleet.AvailabilitySlot.prototype.getTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.AvailabilitySlot.prototype.setTimestamp = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 seats_remaining = 2;
 * @return {number}
 */
proto.fleet.AvailabilitySlot.prototype.getSeatsRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.AvailabilitySlot.prototype.setSeatsRemaining = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string lead_time = 3;
 * @return {string}
 */
proto.fleet.AvailabilitySlot.prototype.getLeadTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.AvailabilitySlot.prototype.setLeadTime = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Reservation reservations = 4;
 * @return {!Array<!proto.fleet.Reservation>}
 */
proto.fleet.AvailabilitySlot.prototype.getReservationsList = function() {
  return /** @type{!Array<!proto.fleet.Reservation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.Reservation, 4));
};


/** @param {!Array<!proto.fleet.Reservation>} value */
proto.fleet.AvailabilitySlot.prototype.setReservationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.fleet.Reservation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.Reservation}
 */
proto.fleet.AvailabilitySlot.prototype.addReservations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.fleet.Reservation, opt_index);
};


proto.fleet.AvailabilitySlot.prototype.clearReservationsList = function() {
  this.setReservationsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.StationReservationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.StationReservationsRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.StationReservationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.StationReservationsRequest.displayName = 'proto.fleet.StationReservationsRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.StationReservationsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.StationReservationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.StationReservationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.StationReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationReservationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    stationId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sortOrderList: jspb.Message.getRepeatedField(msg, 3),
    cursor: jspb.Message.getFieldWithDefault(msg, 4, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.StationReservationsRequest}
 */
proto.fleet.StationReservationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.StationReservationsRequest;
  return proto.fleet.StationReservationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.StationReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.StationReservationsRequest}
 */
proto.fleet.StationReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStationId(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.fleet.StationReservationSortOrder>} */ (reader.readPackedEnum());
      msg.setSortOrderList(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCursor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.StationReservationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.StationReservationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.StationReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationReservationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSortOrderList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getCursor();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 station_id = 1;
 * @return {number}
 */
proto.fleet.StationReservationsRequest.prototype.getStationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.StationReservationsRequest.prototype.setStationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated StationReservationSortOrder sort_order = 3;
 * @return {!Array<!proto.fleet.StationReservationSortOrder>}
 */
proto.fleet.StationReservationsRequest.prototype.getSortOrderList = function() {
  return /** @type {!Array<!proto.fleet.StationReservationSortOrder>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<!proto.fleet.StationReservationSortOrder>} value */
proto.fleet.StationReservationsRequest.prototype.setSortOrderList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.fleet.StationReservationSortOrder} value
 * @param {number=} opt_index
 */
proto.fleet.StationReservationsRequest.prototype.addSortOrder = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.fleet.StationReservationsRequest.prototype.clearSortOrderList = function() {
  this.setSortOrderList([]);
};


/**
 * optional int32 cursor = 4;
 * @return {number}
 */
proto.fleet.StationReservationsRequest.prototype.getCursor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.StationReservationsRequest.prototype.setCursor = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 per_page = 5;
 * @return {number}
 */
proto.fleet.StationReservationsRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.StationReservationsRequest.prototype.setPerPage = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.fleet.StationReservationSortOrder = {
  STATIONRESERVATIONSORTORDER_UNSET: 0,
  STATIONRESERVATIONSORTORDER_ORIGIN: 1,
  STATIONRESERVATIONSORTORDER_DESTINATION: 2,
  STATIONRESERVATIONSORTORDER_TIME: 3
};

goog.object.extend(exports, proto.fleet);
